import Typed from 'typed.js';
import { default as Player } from '@vimeo/player';
import isInViewport from '../util/isInViewport';

export default {
  // JavaScript to be fired on the home page
  init() {

    // once player is fully available thru window.Player
    this.handlePlayPauseStateOnScroll();

    $('.aptim-hero-content-left').on('mouseover', function () {
      $(this).parents('.aptim-hero-container').addClass('left-active');
    });

    $('.aptim-hero-content-right').on('mouseover', function () {
      $(this).parents('.aptim-hero-container').addClass('right-active');
    });

    $('.aptim-hero-content-left').on('mouseleave', function () {
      $(this).parents('.aptim-hero-container').removeClass('left-active');
    });

    $('.aptim-hero-content-right').on('mouseleave', function () {
      $(this).parents('.aptim-hero-container').removeClass('right-active');
    });

    document.getElementById('vimeo-home-hero-iframe-left').onload = () => this.handleVideoOnload('.aptim-hero-left', 'LeftPlayer');
    document.getElementById('vimeo-home-hero-iframe-right').onload = () => this.handleVideoOnload('.aptim-hero-right', 'RightPlayer');
    const that = this;

    $(window).on('resize', function() {
      if ($(window).width() > 991) {
        window.LeftPlayer?.pause();
        window.RightPlayer?.pause();
        $('.aptim-hero-left iframe').css('visibility', 'hidden');
        $('.aptim-hero-right iframe').css('visibility', 'hidden');
      } else {
        window.LeftPlayer?.play();
        window.RightPlayer?.play();
        $('.aptim-hero-left iframe').css('visibility', 'visible');
        $('.aptim-hero-right iframe').css('visibility', 'visible');
      }
      
      that.scaleIframe('.aptim-hero-left');
      that.scaleIframe('.aptim-hero-right');
    });
  },

  scaleIframe(selector) {
    const iframe = document.querySelector(selector + ' > iframe');
    const container = document.querySelector(selector);

    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;

    const scale = Math.max(containerWidth / 16, containerHeight / 9);
    const newWidth = scale * 16;
    const newHeight = scale * 9;

    iframe.style.width = newWidth + 'px';
    iframe.style.height = newHeight + 'px';
  },

  handlePlayPauseStateOnScroll() {
    const leftHeroVideoContainer = document.querySelector('.aptim-hero-content-left');
    const rightHeroVideoContainer = document.querySelector('.aptim-hero-content-right');

    leftHeroVideoContainer?.addEventListener('mouseover', () => this.handleVideoState(window.LeftPlayer, '.aptim-hero-left', true));
    leftHeroVideoContainer?.addEventListener('mouseleave', () => this.handleVideoState(window.LeftPlayer, '.aptim-hero-left'));

    rightHeroVideoContainer?.addEventListener('mouseover', () => this.handleVideoState(window.RightPlayer, '.aptim-hero-right', true));
    rightHeroVideoContainer?.addEventListener('mouseleave', () => this.handleVideoState(window.RightPlayer, '.aptim-hero-right'));
  },

  handleVideoState(player, containerClass, play = false) {
    const container = $(containerClass);
    if ($(window).width() > 991) {
      play ? player?.play() : player?.pause();
      container?.find('iframe').css('visibility', 'visible');
    }
  },

  handleVideoOnload(selector, playerName) {
    let iframe = $(selector + " > iframe");

    if (iframe.length > 0) {
      const player = new Player(iframe, { controls: false });
      window[playerName] = player;

      if ($(window).width() > 991) {
        player?.pause();
        iframe.css('visibility', 'hidden');
      } else {
        iframe.css('visibility', 'visible');
      }
    }

    this.scaleIframe('.aptim-hero-left');
    this.scaleIframe('.aptim-hero-right');
  },
};
